var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_80_518)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7433 36.5976C32.4096 36.5976 32.0833 36.6973 31.8058 36.8841C31.5283 37.071 31.3119 37.3367 31.1842 37.6475C31.0564 37.9583 31.0229 38.3004 31.088 38.6304C31.153 38.9604 31.3137 39.2635 31.5496 39.5015C31.7855 39.7395 32.0862 39.9015 32.4135 39.9672C32.7408 40.0329 33.0801 39.9993 33.3885 39.8706C33.6968 39.7419 33.9604 39.5239 34.1459 39.2442C34.3314 38.9645 34.4304 38.6356 34.4305 38.2991C34.4304 37.848 34.2526 37.4154 33.9363 37.0963C33.6199 36.7772 33.1908 36.5979 32.7433 36.5976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2789 36.5976C25.9452 36.5976 25.619 36.6974 25.3415 36.8843C25.064 37.0712 24.8477 37.3369 24.72 37.6477C24.5922 37.9586 24.5588 38.3006 24.6239 38.6306C24.689 38.9606 24.8497 39.2637 25.0856 39.5016C25.3216 39.7395 25.6222 39.9016 25.9495 39.9673C26.2768 40.0329 26.6161 39.9993 26.9244 39.8706C27.2328 39.7419 27.4964 39.5239 27.6818 39.2442C27.8673 38.9645 27.9663 38.6356 27.9663 38.2991C27.9662 37.848 27.7884 37.4153 27.4719 37.0963C27.1555 36.7772 26.7264 36.5979 26.2789 36.5976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2808 20.2849H21.6518L21.1776 16.7341C21.109 16.2208 20.8247 16 20.3201 16H16.844C16.6202 16 16.4055 16.0896 16.2472 16.2492C16.0889 16.4088 16 16.6252 16 16.8509C16 17.0766 16.0889 17.293 16.2472 17.4526C16.4055 17.6122 16.6202 17.7018 16.844 17.7018H19.5958L21.5676 29.7974C21.8961 31.8795 22.368 33.897 25.0522 33.897H34.3334C37.0509 33.897 37.3497 31.9421 37.8373 29.9746L39.9077 21.6233C40.0678 20.978 40.1072 20.2849 39.2808 20.2849ZM37.5969 24.1376H26.1115C25.8879 24.1382 25.6736 24.228 25.5155 24.3874C25.3574 24.5468 25.2683 24.7628 25.2677 24.9882C25.2683 25.2136 25.3574 25.4296 25.5155 25.589C25.6736 25.7484 25.8879 25.8382 26.1115 25.8388H37.1748L36.6946 27.7811H28.1774C27.9539 27.7819 27.7397 27.8718 27.5817 28.0311C27.4237 28.1905 27.3346 28.4064 27.334 28.6317C27.3346 28.857 27.4237 29.0729 27.5817 29.2322C27.7398 29.3915 27.9539 29.4813 28.1774 29.482H36.2713L36.1816 29.8432C35.9152 30.9195 35.854 32.1926 34.3334 32.1926H25.0522C23.4455 32.1926 23.4052 30.7368 23.214 29.5795L21.9582 21.9861H38.1303L37.5969 24.1376Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_80_518",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.92 0 0 0 0 0 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_80_518"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_80_518",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.af2d2f86102973c1cda959a01d8b57c2.svg";
export { ForwardRef as ReactComponent };